import React, { useState, useEffect } from 'react';


function ViewDays({ investment, closeModal }) {
  // Move hooks to the top level
 



  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };





  if (!investment) return null;

  return (
    <div className="modal fade viewbox edit-box show d-block" tabIndex={-1} aria-labelledby="userModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            {/* <h5 className="modal-title">User Details</h5> */}
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="container">

              <div className="d-flex" style={{gap: "15px"}}>
                    <div className="container-box user-manager" style={{ padding: "10px", marginTop: "0", flex: "1"}}>
                    <ul className='user-details list-unstyled d-flex justify-content-between'>
                        <li className='text-start'>
                            <span>Check In Date: </span>
                            <span>{formatDate(investment?.checkInDate || 'N/A')}</span>
                            </li>
                        </ul>
                    </div>
                    <div className="container-box user-manager" style={{ padding: "10px", marginTop: "0", flex: "1" }}>
                        <ul className='user-details list-unstyled d-flex justify-content-between'>
                            <li className='text-start'>
                            <span>Check Out Date: </span>
                            <span>{formatDate(investment?.checkOutDate || 'N/A')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
          </div>
         
        </div>
      </div>
    
    </div>
  );
}

export default ViewDays;
